var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloseCross = function SvgCloseCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 14 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.282 13.51 13.01.782l.708.708L.99 14.218z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M.99.782 13.718 13.51l-.708.708L.282 1.49z"
  })));
};
export { SvgCloseCross as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMiIgaGVpZ2h0PSIxMiIgdmlld0JveD0iMCAwIDE0IDE1Ij48Zz4KICAgIDxnIHRyYW5zZm9ybT0icm90YXRlKC00NSA3IDcuNSkiPjxwYXRoIGQ9Ik0tMiA3aDE4djFILTJ6Ii8+PC9nPgogICAgPGcgdHJhbnNmb3JtPSJyb3RhdGUoLTMxNSA3IDcuNSkiPjxwYXRoIGQ9Ik0tMiA3aDE4djFILTJ6Ii8+PC9nPjwvZz48L3N2Zz4=";